import { useNavigate, useSearch } from '@tanstack/react-router';
import { useEffect, useState } from 'react';

/**
 * React hook which syncs table's global filter state to URL query search.
 * `searchParam` configures the search param name under which the state
 * will be persited in the URL.
 */
export function useTableSearchQuery({ searchParam }: { searchParam: string }) {
  const navigate = useNavigate();
  const urlValue = useSearch({
    strict: false,
    select: (search: Record<string, unknown>) => toSearchText(search[searchParam]),
  });

  const [globalFilter, setGlobalFilter] = useState(urlValue);

  useEffect(() => {
    void navigate({
      to: '.',
      search: (old: Record<string, unknown>) => ({
        ...old,
        [searchParam]: globalFilter || undefined,
      }),
      replace: true,
    });
  }, [navigate, searchParam, globalFilter]);

  return [globalFilter, setGlobalFilter] as const;
}

function toSearchText(value: unknown): string {
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }
  return '';
}
